export const DEFAULT_CONFIG = {
  brand: 'MINHA MARCA',
  primaryColor: '#e8272a',

  nav: {
    logoImage: '',
    linkStartProject: '#',
    linkAbout: '#',
    linkSport: '#',
    linkShop: '#',
  },

  logos: {
    items: [],
  },

  hero: {
    titleLine1: 'KITS PERSONALIZADOS',
    titleLine2: 'SEM LIMITES',
    fontSize: 86,
    subtitle: 'Receba uniformes e vestuário projetados profissionalmente para o seu clube, com o primeiro rascunho entregue hoje.',
    ctaText: 'COMEÇAR AGORA',
    ctaLink: '#',
    bgImage: '',
    bgFallback: '#111111',
  },

  boring: {
    visible: true,
    title: 'PARE DE USAR OS MESMOS\nTEMPLATES CHATOS',
    subtitle: 'Kits personalizados não são só para clubes profissionais. De seleções nacionais a ligas amadoras, levamos uniformes de classe mundial para clubes de todos os tamanhos.',
    ctaText: 'COMEÇAR AGORA',
    ctaLink: '#',
  },

  portfolio: {
    visible: true,
    title: 'NOSSOS PARCEIROS',
    items: [],
  },

  reviews: {
    visible: true,
    title: 'O QUE DIZEM SOBRE NÓS',
    subtitle: 'Veja o que nossos clientes falam sobre nossos serviços.',
    googleScore: '5.0',
    reviewCount: '0',
    items: [],
  },

  howItWorks: {
    visible: true,
    title: 'COMO FUNCIONA',
    steps: [
      { icon: '📋', title: '1. O FORMULÁRIO', description: 'Preencha nosso formulário para nos contar o que seu clube precisa.' },
      { icon: '🎨', title: '2. O DESIGN',     description: 'Nossa equipe trabalhará com você para criar seus uniformes personalizados.' },
      { icon: '🏆', title: '3. A REVELAÇÃO',  description: 'Fabricamos e enviamos diretamente para você. Agora seu clube tem os melhores kits da liga!' },
    ],
  },

  footer: {
    tagline: 'Cadastre-se para receber novidades e ofertas exclusivas.',
    emailPlaceholder: 'Digite seu e-mail',
    copyright: '© 2025 Minha Marca',
    socials: {
      instagram: '#',
      facebook: '#',
      twitter: '#',
      tiktok: '#',
    },
    links: [
      { label: 'Página Inicial', href: '#' },
      { label: 'Fale Conosco',   href: '#' },
      { label: 'Perguntas Frequentes', href: '#' },
      { label: 'Política de Privacidade', href: '#' },
      { label: 'Termos de Serviço', href: '#' },
    ],
  },

  testimonials: {
    visible: true,
    title: 'O QUE DIZEM SOBRE NÓS',
    items: [],
  },

  location: {
    visible: false,
    title: 'Nossa Localização',
    subtitle: '',
    embedUrl: '',
    address: '',
    phone: '',
    hours: '',
  },

  categories: {
    visible: true,
    title: 'NOSSOS DESIGNS',
    subtitle: 'Explore nossa coleção de uniformes personalizados',
    thumbnails: {},
  },
};